import React, { useEffect, useState } from "react";
import NavBar from "./Navbar";
import { useNavigate } from "react-router-dom";

export default function Signup() {
  const [user, setUser] = useState([]);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleSet = () => {
    setUser([...user, { email, password }]);
  };
  useEffect(() => {
    if (user?.length > 0) {
      localStorage.setItem("sign", JSON.stringify(user));
    }
  }, [user]);

  useEffect(() => {
    var data = localStorage.getItem("sign");
    if (data) setUser(JSON.parse(data));
  }, []);

  var navigate = useNavigate();
  const handleloginData = (e) => {
    e.preventDefault();
    const user_name = user.filter((item) => item.user === email);
    console.log("user", user_name);

    if (user_name[0]["pass"] === password) {
      alert("login");
      navigate("/");
    } else {
      alert("invalid");
      navigate("/log");
    }
  };

  return (
    <>
      <NavBar />
      <div class="login-box">
        <h2>Signup</h2>
        <form onSubmit={(e) => handleloginData(e)}>
          <div class="user-box">
            <input
              type="text"
              onChange={(e) => setEmail(e.target.value)}
              name=""
              required=""
            />{" "}
            <label>Email</label>
          </div>
          <div class="user-box">
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              name=""
              required=""
            />
            <label>Password</label>
          </div>
          <button type="submit" onClick={() => handleSet()}>
            Submit
          </button>
        </form>
      </div>
    </>
  );
}
